import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { AppleIcon, PlayIcon } from "../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";
import FskCaseVideo from "../../images/services-usa/game_update/fsk_case_vid.mp4";
import FskCaseWebm from "../../images/services-usa/game_update/fsk_case_webm.webm";
import EtherCaseVideo from "../../images/services-usa/game_update/ether_case-vid.mp4";
import EtherCasewebm from "../../images/services-usa/game_update/ether_case_webm.webm";
import ParcheesiCaseVideo from "../../images/services-usa/game_update/parcheesi_case_video.mp4";
import ParcheesiCaseWebm from "../../images/services-usa/game_update/parcheesi_case_webm.webm";

function CaseStudy(props) {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [userInteracted, setUserInteracted] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const handleUserInteraction = () => {
      setUserInteracted(true);
    };

    const interactionEvents = [
      "click",
      "mousemove",
      "touchstart",
      "keydown",
      "scroll",
      "mouseover",
    ];

    interactionEvents.forEach((event) =>
      document.addEventListener(event, handleUserInteraction)
    );

    return () => {
      interactionEvents.forEach((event) =>
        document.removeEventListener(event, handleUserInteraction)
      );
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && userInteracted) {
          setVideoLoaded(true);
          observer.disconnect(); // Stop observing once the video is loaded
        }
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer && sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [userInteracted]);
  return (
    <section className="casestudy p-100" id="case_btn" ref={sectionRef}>
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={5}>
            <h2>Our Portfolio</h2>
            <p>
              Tekrevol Games provides knowledge and experience so our partners
              can deliver high quality entertainment.
            </p>
          </Col>
          <Col xs={12} md={6} lg={6} xl={7}>
            <div className="pro_btn">
              <Link to="/" aria-label="TekRevol Contact" className="border_btn">
                All case studies
              </Link>
            </div>
          </Col>
        </Row>
        <Row className="pro_sec">
          <Col xs={12} md={12} lg={12}>
            <div className="casestudy_item item_001">
              {videoLoaded ? (
                <video
                  poster={FskCaseVideo}
                  autoPlay
                  loop
                  muted
                  playsInline
                  // className="banner-vid"
                >
                  <source src={FskCaseWebm} type="video/webm" />
                  <source src={FskCaseVideo} type="video/mp4" />
                </video>
              ) : (
                <StaticImage
                  src="../../images/services-usa/game_update/fsk_case_img.webp"
                  alt="TekRevol"
                  className="banner-image"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={1600}
                  height={850}
                />
              )}
              {/* <LazyLoadImage
                alt="case_Study"
                effect="blur"
                src={Case01}
                width="100%"
                height="100%"
              /> */}
              <div className="download_section">
                <div className="download_apps">
                  <div className="name_now">Available Now!</div>
                  <div className="name_icon">
                    <ul>
                      <li>
                        <Link to="">{PlayIcon}</Link>
                      </li>
                      <li>
                        <Link to="">{AppleIcon}</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="case_btn">
                  <Link
                    to="/case-studies/fsk"
                    aria-label="TekRevol Contact"
                    className="border_btn"
                  >
                    view case study
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6}>
            <div className="casestudy_item item_002">
              {videoLoaded ? (
                <video
                  poster={EtherCaseVideo}
                  autoPlay
                  loop
                  muted
                  playsInline
                  // className="banner-vid"
                >
                  <source src={EtherCasewebm} type="video/webm" />
                  <source src={EtherCaseVideo} type="video/mp4" />
                </video>
              ) : (
                <StaticImage
                  src="../../images/services-usa/game_update/ether_case_img.webp"
                  alt="TekRevol"
                  className="banner-image"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={784}
                  height={850}
                />
              )}
              {/* <LazyLoadImage
                alt="case_Study"
                effect="blur"
                src={Case02}
                width="100%"
                height="100%"
              /> */}
              <div className="download_section">
                <div className="download_apps">
                  <div className="name_now">Available Now!</div>
                  <div className="name_icon">
                    <ul>
                      <li>
                        <Link to="">{PlayIcon}</Link>
                      </li>
                      <li>
                        <Link to="">{AppleIcon}</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="case_btn">
                  <Link
                    to="/case-studies/ether-legends"
                    aria-label="TekRevol Contact"
                    className="border_btn"
                  >
                    view case study
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6}>
            <div className="casestudy_item item_003">
              {videoLoaded ? (
                <video
                  poster={ParcheesiCaseVideo}
                  autoPlay
                  loop
                  muted
                  playsInline
                  // className="banner-vid"
                >
                  <source src={ParcheesiCaseWebm} type="video/webm" />
                  <source src={ParcheesiCaseVideo} type="video/mp4" />
                </video>
              ) : (
                <StaticImage
                  src="../../images/services-usa/game_update/parcheesi_case_img.webp"
                  alt="TekRevol"
                  className="banner-image"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={784}
                  height={850}
                />
              )}
              {/* <LazyLoadImage
                alt="case_Study"  
                effect="blur"
                src={Case03}
                width="100%"
                height="100%"
              /> */}
              <div className="download_section">
                <div className="download_apps">
                  <div className="name_now">Available Now!</div>
                  <div className="name_icon">
                    <ul>
                      <li>
                        <Link to="">{PlayIcon}</Link>
                      </li>
                      <li>
                        <Link to="">{AppleIcon}</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="case_btn">
                  <Link
                    to="/case-studies/parcheesi"
                    aria-label="TekRevol Contact"
                    className="border_btn"
                  >
                    view case study
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default CaseStudy;
